import React, { Component } from 'react';
import { TextArea } from '../../../Elements';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import styles from './Notepad.scss';

class Notepad extends Component {

  static propTypes = {
    terms: PropTypes.string,
    update: PropTypes.func.isRequired,
    notes: PropTypes.string
  }

  constructor(props) {
    super(props);
    this.state = {
      notes: this.props.notes
    };
    this.notesChangeHandler = this.notesChangeHandler.bind(this);
  }

  notesChangeHandler(e) {
    this.setState({ notes: e.target.value });
  }

  render() {
    const { notes } = this.state;
    const { update } = this.props;
    return (
      <Formsy.Form className={`ui form field ${styles.notepad}`}>
        <TextArea
          name='notes'
          rows={12}
          onBlur={() => update(notes)}
          onChange={this.notesChangeHandler}
          value={notes || ''}
        />
      </Formsy.Form>
    );
  }

}

export default Notepad;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Notepad/Notepad.js